export enum DeceasedStateName {
    ANY = 'deceased_any_state',
    REGISTERED = 'deceased_registered',
    WAITING_FOR_CREMATION = 'deceased_waiting_for_cremation',
    IN_CREMATION = 'deceased_in_cremation',
    CREMATED = 'deceased_cremated',
    RELEASED = 'deceased_released',
    CANCELLED = 'deceased_cancelled'
}

export enum DeceasedTriggerName {
    DECEASED_STATE_CHANGED = 'deceased_state_changed',
    DECEASED_REGISTER = 'deceased_register',
    DECEASED_RECEIVE = 'deceased_receive',
    DECEASED_SCHEDULE_CREMATION = 'deceased_schedule_cremation',
    DECEASED_START_CREMATION = 'deceased_start_cremation',
    DECEASED_COMPLETE_CREMATION = 'deceased_complete_cremation',
    DECEASED_RELEASE = 'deceased_release',
    DECEASED_CANCEL = 'deceased_cancel',
    DECEASED_IDENTIFICATION_SCANNED = 'deceased_identification_scanned'
}

export enum DeceasedActionName {
    DECEASED_CHANGE_STATE = 'deceased_change_state'
}
